import { page } from '$app/stores';

import { derived } from 'svelte/store';

import type { InstitutionType } from '@do/models';

import { getLinkVisibility, navigationLinks, UFDANavigationLinks } from '../libs';

type NavLinkItem = (typeof navigationLinks)[InstitutionType][number];

export const navigationLinksStore = derived(
  page,
  ($page) => {
    const {
      institutionAuctionsCount,
      institutionArtistsCount,
      institutionNewsCount,
      institutionCuratorsCount,
      institutionSelectionsCount,
      configurations,
      isUFDA,
    } = $page.data;

    const institutionType: InstitutionType = configurations.type;

    const institutionLinks = isUFDA ? UFDANavigationLinks : navigationLinks[institutionType];

    return institutionLinks.filter(({ title }) =>
      getLinkVisibility(title, {
        hasAuctions: institutionAuctionsCount > 0,
        hasArtists: institutionArtistsCount > 0,
        hasNews: institutionNewsCount > 0,
        hasCurators: institutionCuratorsCount > 0,
        hasSelections: institutionSelectionsCount > 0,
      }),
    );
  },
  [] as NavLinkItem[],
);
